import { APP_ROUTES } from '@lib/route/constants';
import { Tenant } from '@lib/tenants/types';

export const KIOSK_BESTCONNECT_CONFIG: Tenant = {
  config: {
    setup: {
      id: {
        local: 'BEST_CONNECT',
        demo: undefined,
        qa: undefined,
        prod: 'BEST_CONNECT',
        staging: 'BEST_CONNECT',
      },
      name: 'kiosk-bestconnect',
      cmsSubdomain: {
        local: 'bestconnect-staging',
        demo: undefined,
        staging: 'bestconnect-staging',
        qa: undefined,
        prod: 'bestconnect-production',
      },
      ryftPublicKey: {
        local: undefined,
        demo: undefined,
        qa: undefined,
        prod: undefined,
        staging:
          'pk_sandbox_wCLdq9JLAk1H+gqjotrJ4Thr6VaUI3+2CTpruusTyVnFeE54vPMiF9B+hYVa0kyy',
      },
      stripePublicKey: {
        local: undefined,
        demo: undefined,
        staging: undefined,
        prod: 'pk_live_51HHZFYAViM5pzfBS2Oj5vssICryq1wGMh1RVAhIt2NAadwSkjPAiCFluR6fObh2RSkAucmYXNhpNMlgRwJoqPQu000DYLsTVGA',
        qa: undefined,
      },
      paypalPublicKey: {
        local: undefined,
        demo: undefined,
        qa: undefined,
        prod: 'AeX-ALLC2IKRmGlcy1y6fRkfTfSzxV4zlq4Ld3TMSBCd2EsfE-EMouTpadsyVkqknSDmzjl9ydcvJAjh',
        staging: undefined,
      },
      authTenantId: {
        local: '5nxwvmvb',
        demo: undefined,
        staging: '5nxwvmvb',
        qa: undefined,
        prod: '8b6mjjjn',
      },
      ocbDigitalBaseUrl: {
        demo: undefined,
        qa: undefined,
        prod: 'https://kiosk.bestconnect.online/digital/api',
        staging: 'https://kiosk-staging.bestconnect.online/digital/api',
      },
    },
    externalHomePageUrl: 'https://www.bestconnect.online/',
  },
  cmsRoutes: [
    {
      type: 'page',
      path: APP_ROUTES.ROOT_UID.path,
    },
    {
      type: 'home-page',
      path: APP_ROUTES.HOME.path,
    },
    {
      type: 'privacy-policy',
      path: APP_ROUTES.PRIVACY_POLICY.path,
    },
    {
      type: 'available_products',
      path: APP_ROUTES.PLANS.path,
    },
    {
      type: 'terms-and-conditions',
      path: APP_ROUTES.TERMS_AND_CONDITIONS.path,
    },
  ],
  theme: {},
  seo: {
    displayName: 'Best connect',
  },
};
